import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { ReactComponent as CheckmarkCircle } from '../../../../../assets/icons/checkmark-circle.svg'
import { useNLUDataStore } from '../../../../../stores/nluDataStore'

import styles from './add-example-tab.module.scss'

function AddExampleTab() {
    const { tab } = useParams()

    const { t } = useTranslation()

    const [{ intents }, { addExample }] = useNLUDataStore()

    const [newExampleText, setNewExampleText] = useState('')
    const [newExampleIntent, setNewExampleIntent] = useState('')

    const cleanInputs = () => {
        setNewExampleIntent('')
        setNewExampleText('')
    }

    const handleAddExample = (
        e: React.FormEvent<HTMLFormElement>,
        text: string,
        intent: string
    ) => {
        e.preventDefault()

        if (!newExampleText || !newExampleIntent) return

        cleanInputs()

        tab &&
            addExample(tab, {
                text,
                intent,
            })
    }

    return (
        <form
            className={styles.addExampleTab}
            onSubmit={(e) =>
                handleAddExample(e, newExampleText, newExampleIntent)
            }
        >
            <input
                className={styles.addExampleTab__input}
                type="text"
                value={newExampleText}
                onChange={(e) => setNewExampleText(e.target.value)}
                placeholder={t('message')}
            />
            <div className={styles.addExampleTab__selectWrapper}>
                <input
                    list="intent"
                    name="intent"
                    value={newExampleIntent}
                    onChange={(e) => setNewExampleIntent(e.target.value)}
                    className={styles.addExampleTab__select}
                    placeholder={t('intent')}
                />
                <datalist id="intent">
                    {intents.map((intent) => (
                        <option key={intent} value={intent}>
                            {intent}
                        </option>
                    ))}
                </datalist>
            </div>
            <button className={styles.addExampleTab__btn} type="submit">
                <CheckmarkCircle
                    className={styles.addExampleTab__icon}
                    alt={t('add')}
                />
                {t('confirm')}
            </button>
        </form>
    )
}

export default AddExampleTab
